module.exports = __webpack_public_path__ + "img/INTERIOR-JIMNY-1.633e75f0.jpg";